import { Component, OnInit } from '@angular/core';
import { MentoratService } from '../../services/mentorat.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { tap } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { DocumentType } from 'src/app/model/documentType.model';
import { FormGroup } from '@angular/forms';
import { DocumentDetails } from 'src/app/model/documentDetails.model';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-list-dossier-by-candidat-mentorat',
  templateUrl: './list-dossier-by-candidat-mentorat.component.html',
  styleUrls: ['./list-dossier-by-candidat-mentorat.component.css'],
})
export class ListDossierByCandidatMentoratComponent implements OnInit {
  candidatId!: number;
  certificatId!: number;
  candidatName: string = '';
  candidatIUF: string = '';
  cohorte: string = '';
  documentsList: any[] = [];
  currentStatus: string = '';
  selectedStatus: string = '';
  isStatusChanged: boolean = false;
  url: string = config.openBaseUrl;

  formDocument!: FormGroup;
  maxFileSize: number = 5120000;
  user: any;
  fileSize!: number;
  fileName!: string;
  IUF_apprenant!: string;
  file: File | null = null; // Variable to store file
  popupVisible: boolean = false;
  classOpen: string = '';
  documentType: any[] = DocumentType.List;
  isForAddDocument: boolean = false;
  isForUpdateDocument: boolean = false;
  diplomeId!: number;
  diplomeName: string = '';

  documentDetails!: DocumentDetails;
  diplomes!: any[];

  statusOptions = [
    { value: 'En cours de traitement', label: 'En cours' },
    { value: 'Retenu', label: 'Retenu' },
    { value: 'Rejete', label: 'Rejeté' },
  ];

  breadcrumbItems: BreadcrumbItem[] = [];

  fileTypes: Record<string, any> = {
    pdf: {
      label: 'PDF',
      bg: 'bg-red-50',
      text: 'text-red-600',
      icon: 'pdf'
    },

    xls: {
      label: 'Excel',
      bg: 'bg-green-50',
      text: 'text-green-600',
      icon: 'excel'
    },

    xlsx: {
      label: 'Excel',
      bg: 'bg-green-50',
      text: 'text-green-600',
      icon: 'excel'
    },

    doc: {
      label: 'Word',
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      icon: 'word'
    },

    docx: {
      label: 'Word',
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      icon: 'word'
    },

    png: {
      label: 'Image',
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      icon: 'image'
    },

    jpg: {
      label: 'Image',
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      icon: 'image'
    },

    jpeg: {
      label: 'Image',
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      icon: 'image'
    },

    gif: {
      label: 'Image',
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      icon: 'image'
    }
  };

  constructor(
    private serviceMentorat: MentoratService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: SpinnerServiceService
  ) {
    // this.user = sessionStorage.getItem('user');
    // this.IUF_apprenant = JSON.parse(this.user).iuf;
    const navigation = this.router.getCurrentNavigation();
    // console.log("navigate :", navigation)
    if (navigation?.extras.state) {
      this.certificatId = navigation.extras.state['certificatId'];
      this.candidatName = navigation.extras.state['candidatName'];
      this.candidatIUF = navigation.extras.state['candidatIUF'];
      // console.log(this.candidatIUF);
      this.currentStatus = navigation.extras.state['status'];
      this.selectedStatus = this.currentStatus;
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.candidatId = +params['candidatId'];
      this.certificatId = +params['certificatId'];
      this.candidatName = params['candidatName'] || '';
      this.candidatIUF = params['candidatIUF'];
      this.cohorte = params['cohorte'] || '';
      this.currentStatus = params['status'] || '';
      this.selectedStatus = this.currentStatus;
      // console.log('candidat iuf:', this.candidatIUF);
      this.breadcrumbItems = [
        { label: 'MENTORAT' },
        { label: 'CANDIDATS MENTORS', url: '/dashboard/users/list-mentors' },
        { label: `DOSSIER DE ${this.candidatName.toUpperCase()}` },
      ];
      if (this.candidatIUF) {
        this.getFolder();
      } else {
        console.error("Impossible d'appeler getFolder : IUF est manquant !");
      }
    });
  }

  getFolder(): void {
    this.spinner.showSpinner();
    this.serviceMentorat
      .getApprenantDocuments(this.candidatIUF)
      .pipe(
        tap((response) => {
          this.documentsList = response.object;
          this.spinner.hideSpinner();
          // console.log('documents : ', this.documentsList);
        }),
      )
      .subscribe();
  }

  onStatusSelectionChange(newStatus: string): void {
    this.isStatusChanged = newStatus !== this.currentStatus;
  }

  saveStatusChange(): void {
    if (!this.isStatusChanged || this.selectedStatus === this.currentStatus) {
      return;
    }

    this.serviceMentorat
      .updateCandidatureCertificatStatus(
        this.candidatId,
        this.certificatId,
        this.selectedStatus,
      )
      .subscribe({
        next: (response) => {
          // console.log('Statut mis à jour avec succès');
          this.currentStatus = this.selectedStatus;
          this.isStatusChanged = false;
          const cached = localStorage.getItem('last_evaluated_candidat');
          if (cached) {
            let candidate = JSON.parse(cached);
            const certIndex = candidate.certificats.findIndex((c: any) => c.id === this.certificatId);
            if (certIndex > -1) {
              candidate.certificats[certIndex].status = this.selectedStatus;
              localStorage.setItem('last_evaluated_candidat', JSON.stringify(candidate));
            }
          }
          this.goBack();
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour du statut:', error);
        },
      });
  }

  openDoc(document: any): void {
    document.isOpened = true;
    window.open(this.url + '/opencontroller/view/' + document.url, '_blank');
  }

  goBack(): void {
    this.router.navigate(['/dashboard/users/list-mentors'], {
      queryParams: { openModal: 'true', candidatId: this.candidatId }
    });
  }
  getFileExtension(filename: string): string {
    return filename?.split('.').pop()?.toLowerCase() || '';
  }

  getFileType(fileName: string) {
    if (!fileName) {
      return {
        label: 'Document',
        bg: 'bg-slate-100',
        text: 'text-slate-600',
        icon: 'file'
      };
    }

    const extension = fileName
      .split('.')
      .pop()
      ?.toLowerCase();

    return (
      this.fileTypes[extension || ''] || {
        label: 'Document',
        bg: 'bg-slate-100',
        text: 'text-slate-600',
        icon: 'file'
      }
    );
  }
}
